import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_PESANAN_ALL, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_PESANANALL = 'GET_LIST_PESANANALL';

export const getPesananAll = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_PESANANALL);

    axios({
      method: 'get',
      url: GET_PESANAN_ALL,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_PESANANALL, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_PESANANALL,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_PESANANALL, error);
        alert(error);
      });
  };
};
